import { Routes } from '@angular/router';
import { DynamicDataSetWorkspaceComponent } from './components/dynamic-dataset-workspace.component';
import { DynamicRuleWorkspaceComponent } from './components/dynamic-rule-workspace.component';

export const routes: Routes = [
  {
    path: 'dynamic-dataset-workspace/:key',
    component: DynamicDataSetWorkspaceComponent,
    data: {
      permissions: ['DynamicDataSetModule.DynamicDataSets:View']
    }
  },
  {
    path: 'dynamic-rule-workspace/:dataSetKey/:key',
    component: DynamicRuleWorkspaceComponent,
    data: {
      permissions: ['DynamicDataSetModule.DynamicDataSets:View']
    }
  }
];



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/routes.config.ts